import { render } from "./UiBurgerMenuIcon.vue?vue&type=template&id=b186fe30&scoped=true&lang=pug"
import script from "./UiBurgerMenuIcon.vue?vue&type=script&lang=js"
export * from "./UiBurgerMenuIcon.vue?vue&type=script&lang=js"

import "./UiBurgerMenuIcon.vue?vue&type=style&index=0&id=b186fe30&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b186fe30"]])

export default __exports__